// Check if user is authenticated
export const isAuthenticated = () => {
  return !!localStorage.getItem('authToken');
};

// Store auth token
export const setAuthToken = (token) => {
  localStorage.setItem('authToken', token);
};

// Get auth token
export const getAuthToken = () => {
  return localStorage.getItem('authToken');
};

// Clear auth token
export const clearAuthToken = () => {
  localStorage.removeItem('authToken');
};
